<template>
  <div v-if="stylesLoaded" class="flex flex-col gap-8">
    <actual-times-table />
    <sold-time-table />
  </div>
</template>

<script>
import ActualTimesTable from "@/Job/ActualTimesTable.vue";
import SoldTimeTable from "@/Job/SoldTimeTable.vue";

export default {
  components: {
    ActualTimesTable,
    SoldTimeTable
  },
  data() {
    return {
      stylesLoaded: false
    };
  },
  async created() {
    await import("../../components/datatable_tailwind.css");
    this.stylesLoaded = true;
  }
};
</script>

<style lang="scss" scoped></style>
